export { MessageCircle as default } from './MessageCircle';
